<div class="search-container">
  <input
    class="search-input"
    type="text"
    [placeholder]="placeholder"
    [value]="value"
    (input)="handleSearchChanged($event)" />
</div>
